import { render, staticRenderFns } from "./ModalMotivoCancelamento.vue?vue&type=template&id=cb8c5ce8"
import script from "./ModalMotivoCancelamento.vue?vue&type=script&lang=js"
export * from "./ModalMotivoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports